<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
          color="#0F998E"
          class="white--text float-right"
          v-on="on"
        >
          Dodaj
          <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        primary-title
      >
        Skupine
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              label="Ime skupine"
              v-model="searchString"
              ref="search"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-container class="results-container">
          <v-row
            v-if="filteredCategories"
            class="results"
          >
            <v-col
              cols="12"
              v-for="item of filteredCategories"
              :key="item.id"
            >
              <v-btn
                style="width: 100%"
                class="float-right"
                :outlined="selectedCategories.some((e) => e.id === item.id)"
                @click="toggleSelectedCategory(item)"
              >
                {{item.name}}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#0F998E"
          text
          @click="dialog = false"
        >
          Prekliči
        </v-btn>
        <v-btn
          color="#0F998E"
          text
          @click="saveSelected"
        >
          Dodaj
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { siIncludes } from '@/utils/str'

export default {
  props: {
    categoryId: {
      required: true,
      type: Number
    },
    levelCategories: {
      required: true,
      type: Array
    },
    allCategories: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      dialog: false,
      searchString: '',
      selectedCategories: []
    }
  },
  computed: {
    allCategoriesThatAreNotNeeded () {
      const addedIds = this.levelCategories.map(ar => ar.id)
      return this.allCategories.filter(ar => {
        if (ar.id !== this.categoryId) return !addedIds.includes(ar.id)
      })
    },
    filteredCategories () {
      return this.allCategoriesThatAreNotNeeded.filter(category => siIncludes({ haystack: category.name, needle: this.searchString }))
    }
  },
  methods: {
    ...mapActions('businessUnits', ['setCommentCategory']),
    toggleSelectedCategory (category) {
      if (this.selectedCategories.some(ar => ar.id === category.id)) {
        this.selectedCategories = this.selectedCategories.filter(ar => ar.id !== category.id)
      } else {
        this.selectedCategories.push(category)
      }
    },
    saveSelected () {
      const arejSkupin = []
      this.selectedCategories.forEach(skupina => {
        arejSkupin.push(skupina)
      })
      this.$emit('izbraneKategorije', { listaKategorij: arejSkupin, categoryId: this.categoryId })
      /* this.$notify({
        type: 'success',
        text: 'Podskupina je bila uspešno dodana in shranjena.'
      }) */
      this.dialog = false
      this.selectedCategories = []
    }
  },
  watch: {
    dialog (dialog) {
      if (dialog) {
        setTimeout(() => {
          this.$refs.search.focus()
        }, 50)
      }
      this.searchString = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.results-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
